<script>
  export let icon;
  export let onClick;
  export let borderRadius = '2px';
</script>

<div class='icon-button' on:click={onClick}
  style='--text-area-border-radius: {borderRadius};'>

  <div class='icon-button-icon'>
    <span class='material-icons'> {icon} </span>
  </div>
</div>

<style>
  .icon-button {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 20px;
    height: 20px;

    border-radius: var(--text-area-border-radius);

    cursor: pointer;
    user-select: none;

    transition: background-color 0.25s ease-in-out;
  }

  .icon-button:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  .icon-button:active {
    background-color: rgba(0, 0, 0, 0.2);
  }

  :global(body.dark) .icon-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  :global(body.dark) .icon-button:active {
    background-color: rgba(255, 255, 255, 0.2);
  }

</style>
